// JS for block-specific behavior only
console.log('res feature tree block loaded');